module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.css ? 'm-btn m-btn--' + _vm.css : 'm-btn m-btn--default',
    attrs: {
      "type": _vm.type ? _vm.type : 'submit'
    }
  }, [_vm._t("default", [_vm._v("ボタン")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a82f5d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/Button.vue
// module id = 1430
// module chunks = 0